export const linksForKnowledgeBase = new Map([
  ['/admin', '/knowledge_base'],
  ['/', '/knowledge_base/summary-section/summary'],
  ['/bookings', '/knowledge_base/booking/booking'],
  ['/planning', '/knowledge_base/shahmotka/booking-check-in'],
  ['/tariffs/apartments', '/knowledge_base/rooms-and-rates/room-category'],
  ['/tariffs/rooms', '/knowledge_base/rooms-and-rates/room-availability'],
  ['/tariffs', '/knowledge_base/rooms-and-rates/creating-tariff'],
  ['/tariffs/prices', '/knowledge_base/rooms-and-rates/prices-restrictions'],
  ['/reviews', '/knowledge_base/summary-section/summary'],
  ['/gallery', '/knowledge_base/photo/redactirovanie-photo'],
  ['/camp/cancellation_rules', '/knowledge_base/object/configure-rules'],
  ['/camp/services', '/knowledge_base/object/services-conveniences'],
  ['/camp/medical_services', '/knowledge_base/object/medical-services'],
  ['/camp/info', '/knowledge_base/object/requisites'],
  ['/camp/contracts', '/knowledge_base/object/contracts'],
  ['/camp/settings', '/knowledge_base/object/object-settings'],
  ['/finances/agent_report', '/knowledge_base/finance/reports'],
  ['/finances/reconciliation_report', '/knowledge_base/finance/collation'],
  ['/contacts', '/knowledge_base/contacts/adding-contacts'],
  ['/accounts', '/knowledge_base/users/adding-user'],
  ['/notifications_settings', '/knowledge_base/notifications/setting-notifications'],
  ['/channel_manager', '/knowledge_base/object/how-connect-channel-manager']
]);
